import { createContext, useContext, useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { ChildProps } from "../../types/types";
import { useNavigate } from "react-router-dom";
import { createNewIdea, getDiscoveryIdea, getIdeaMatches, getRecentQueries, getRequestsMatchesForAnIdea, getSuggestionsForIdea , saveIdea} from "../../Api";
import { getCalculatedPerspectiveForRequestDiscoveryNew } from "../ideaNiv/helpers/aggregateRequestCompanyData";
import { SortState } from "../ideaNiv/IdeaContext";
import FiltersContext from "../ideas/filters/context/FiltersContext";
import { sortRequests } from "../ideaNiv/helpers/sortRequests";
import MiniSearch from "minisearch";
import { filterRequests } from "../ideaNiv/NewIdeaView";
import {useKnowledgeData} from "../../hooks/useKnowledgeData";
import {useIdeaFilters} from "../../hooks/useIdeaFilters";
import {useFields} from "../../hooks/useFields";
import { useCurrentUser } from "../../hooks/useCurrentUser";

interface DiscoveryContextType {
  ideaId: string | undefined;
  idea: any;
  setIdea: any;
  setIdeaId: any;
  revalidate: boolean;
  setRevalidate: React.Dispatch<React.SetStateAction<boolean>>;
  matches: any[];
  createIdeaDiscovery: (text: string)=> void;
  chosenEvidence: any;
  setChosenEvidence: React.Dispatch<React.SetStateAction<any>>;
  chooseMatch: (id: string, isFromSearch: boolean)=> void;
  type: string;
  setType: React.Dispatch<React.SetStateAction<string>>;
  perspectiveData: { [key: string]: any };
  getMatches: ()=> void;
  matchesTimer: ()=> void;
  matchesTrigger: number;
  showValidated: boolean;
  showmatches: boolean;
  loadIdeaMatches: (text: string)=> void;
  displayedMatches: any[];
  setDisplayedMatches: React.Dispatch<React.SetStateAction<any[]>>;
  setDisplayedRequestsMatches:React.Dispatch<React.SetStateAction<any[]>>;
  setMatchesTrend : React.Dispatch<React.SetStateAction<any[]>>;
  setRequestsMatchesTrend : React.Dispatch<React.SetStateAction<any[]>>;
  activeSort: SortState | null;
  setActiveSort: React.Dispatch<React.SetStateAction<SortState | null>>;
  cardOpened: boolean;
  setCardOpened:React.Dispatch<React.SetStateAction<boolean>>;
  ideaMatches: any[];
  activeSearch: boolean;
  setActiveSearch: React.Dispatch<React.SetStateAction<boolean>>; 
  description: string;
  setDescription: React.Dispatch<React.SetStateAction<string>>; 
  convertFromDiscoveryToIdea: (idea: any)=> void;
  loadingEvidenceMatches: boolean;
  loadingIdeasMatches: boolean;
  matchesCompanies: any[];
  requestsMatches: any[];
  displayedRequestsMatches: any[]; 
  requestsMatchesCompanies: any[];
  requestsMatchesTrend: any[];
  matchesTrend: any[],
  quarters: string[];
  setQuarters: React.Dispatch<React.SetStateAction<string[]>>;
  weeks: string[];
  searchEvidence: (text: string)=> void;
  query: string;
  searchedEvidence: any[],
  loadingMatches: boolean,
  setLoadingMatches:  React.Dispatch<React.SetStateAction<boolean>>;
  fetchDiscoveryIdea(id: string): Promise<void>,
  fetchRecentQueries(): Promise<void>,
  recentQueries: any,
  setLoadingIdeasMatches: any;
  setLoadingEvidenceMatches: any;
  setQueryLoader: any;
  queryLoader: boolean;
  noMatchFound: any;
  setComputed: React.Dispatch<React.SetStateAction<boolean>>;
  setMatchesTrigger: React.Dispatch<React.SetStateAction<number>>;
  displayedStrongMatches: any[],
  strongRequestsMatches: any[],
  displayedStrongRequestsMatches: any[],
}

const DiscoveryContext = createContext<DiscoveryContextType>({} as DiscoveryContextType);

const DiscoveryContextProvider = ({ children }: ChildProps) => {

  const auth0 = useAuth0();
  const currentUser = useCurrentUser();
  const nav = useNavigate();
  const { perspectiveConfigurations } = useFields();
  const { defaultStatus , defaultPriority } = useKnowledgeData();
  const { ideasFiltersConfig } = useIdeaFilters();

  const { activeFilters, setActiveFilters } = useContext(FiltersContext)
  const [idea, setIdea] = useState<any>(null);
  const [ideaId, setIdeaId] = useState<any>(null);
  const [revalidate, setRevalidate] = useState<boolean>(false); 
  const [description, setDescription] = useState<any>('');
  const [matches, setMatches] = useState<any[]>([]);
  const [matchesTrend, setMatchesTrend] = useState<any[]>([]);
  const [requestsMatchesTrend, setRequestsMatchesTrend] = useState<any[]>([])
  const [activeSearch, setActiveSearch] = useState<boolean>(false);
  const [displayedMatches, setDisplayedMatches] = useState<any[]>([]);
  const [matchesTrigger, setMatchesTrigger] = useState(0); 
  const [chosenEvidence, setChosenEvidence] = useState<any>(null);
  const [ideaMatches, setIdeaMatches] = useState<any[]>([]);
  const [cardOpened, setCardOpened] = useState(false);
  const [activeSort, setActiveSort] = useState<SortState | null>(null);
  const [loadingEvidenceMatches, setLoadingEvidenceMatches] = useState(false)
  const [loadingIdeasMatches, setLoadingIdeasMatches] = useState(false)
  const [queryLoader, setQueryLoader] = useState(false);
  const [requestsMatches, setRequestsMatches] = useState<any[]>([])
  const [displayedRequestsMatches, setDisplayedRequestsMatches] = useState<any[]>([])
  const [query, setQuery] = useState('')
  const [searchedEvidence, setSearchedEvidence] = useState<any[]>([]);
  const [quarters, setQuarters] = useState<string[]>([]);
  const [weeks, setWeeks] = useState<string[]>([]);
  const [type, setType] = useState("businessName");
  const [perspectiveData, setPerspectiveData] = useState<{
    [key: string]: any;
  }>({
  });
  const [matchesCompanies, setMatchesCompanies] = useState<any[]>([])
  const [requestsMatchesCompanies, setRequestsMatchesCompanies] = useState<any[]>([])
  const [computed, setComputed] = useState(false)
  const [loadingMatches, setLoadingMatches] = useState(false)
  const [recentQueries, setRecentQueries] = useState();
  const [noMatchFound, setNoMatchFound] = useState(false);
  const [strongMatches, setStrongMatches] = useState<any[]>([]);
  const [displayedStrongMatches, setDisplayedStrongMatches] = useState<any[]>([]);
  const [strongRequestsMatches, setStrongRequestsMatches] = useState<any[]>([]);
  const [displayedStrongRequestsMatches, setDisplayedStrongRequestsMatches] = useState<any[]>([]);

  const showValidated = false
  const showmatches = true

  const miniSearch = new MiniSearch({
    fields: ["title", "text", "title1", "text1", "excerpts"], // fields to index for full-text search
    // idField: '_id',
    searchOptions: {
      fuzzy: 0.2,
      prefix: true,
      combineWith: "AND"
    },
  });

  miniSearch.removeAll();

  const allRequests = [...matches, ...requestsMatches];
  
  const dedupedRequests = allRequests.filter((item, index, self) =>
    index === self.findIndex(t => t?._id === item?._id)
  );

  const aligned = dedupedRequests?.map((m: any) => {
    // Extract excerpts text if it exists
    let excerptsText = '';
    if (m?.excerpts && Array.isArray(m.excerpts)) {
      excerptsText = m.excerpts
        .map((excerpt: any) => excerpt?.excerpt || '')
        .filter((text: string) => text.trim() !== '')
        .join(' ');
    }

    return {
      id: m._id,
      title: m?.title,
      text: m?.text,
      title1: m?.textItem?.title,
      text1: m?.textItem?.text,
      excerpts: excerptsText, // Add excerpts as a searchable field
    };
  });

  miniSearch.addAll(aligned);

  const searchEvidence = (text: string) => {
    setQuery(text);

    if (text === "") {
      setActiveSearch(false);
      
    } else {
      const results: any[] = miniSearch.search(text);

      const resIds = results.map((m: any) => m.id);
      const matchedRequests = allRequests.filter((m: any) => {
        return resIds.includes(m._id);
      });

      // Sort results by field priority
      const sortedRequests = matchedRequests.sort((a, b) => {
        const aScore = getFieldMatchScore(a, text);
        const bScore = getFieldMatchScore(b, text);
        return bScore - aScore; // Higher scores first
      });

      setActiveSearch(true);
      setSearchedEvidence(sortedRequests);
      
    }
  };

  // Helper function to score matches based on which fields contain the search text
  const getFieldMatchScore = (item: any, searchText: string) => {
    const lowerSearchText = searchText.toLowerCase();
    let score = 0;
    
    // Check each field and assign priority scores
    if (item?.title?.toLowerCase().includes(lowerSearchText)) score += 100;
    if (item?.textItem?.title?.toLowerCase().includes(lowerSearchText)) score += 80;
    if (item?.text?.toLowerCase().includes(lowerSearchText)) score += 60;
    if (item?.textItem?.text?.toLowerCase().includes(lowerSearchText)) score += 40;
    
    // Check excerpts
    if (item?.excerpts && Array.isArray(item.excerpts)) {
      const excerptsText = item.excerpts
        .map((excerpt: any) => excerpt?.excerpt || '')
        .join(' ')
        .toLowerCase();
      if (excerptsText.includes(lowerSearchText)) score += 20;
    }
    
    return score;
  };
  
  const loadIdeaMatches = (text: string) => {
    getSuggestionsForIdea(text, text, auth0)
      .then((data: any) => {
        setIdeaMatches(data?.ideaMatches || []);
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() =>
        setLoadingIdeasMatches(false)
      ); 
  };

  const convertFromDiscoveryToIdea = (ideaObj: any) => {

    saveIdea(ideaObj, auth0).then((res: any)=>{
      console.log(res)
    }).catch((e: any)=>{
      console.log(e)
    }).finally(()=>{
      nav(`/idea/${ideaId}`)
    })
  }

  const matchesTimer = () => {

    if(computed || !ideaId){

      setLoadingMatches(false)
    
      if(matchesTrigger < 0){
        setLoadingEvidenceMatches(false)
        return
      }
      else{
        setTimeout(
          () => {
            setMatchesTrigger(-100);
          },
          6000
        );
      }  
    }

    else{
      setTimeout(
        () => {
          setMatchesTrigger(prev => prev + 1);
        },
        2000
      );
    }
  };

  const createIdeaDiscovery = (text: string)=>{

    setActiveFilters([])
    setComputed(false) 
    setIdeaId(null) 
    setLoadingIdeasMatches(true)
    setLoadingEvidenceMatches(true)
    setQueryLoader(false);
    if(!loadingMatches){
      setLoadingMatches(true)
    }
    const newObj = { idea:
      
      { title: '',
        description: text,
        ownerId: currentUser?.id,
        status: defaultStatus,
        priority: defaultPriority,
        state: 'draft'}
    };

    createNewIdea(newObj, auth0)
      .then((response) => {
        const newId = response?.idea?._id;
        setIdea(response?.idea)
        if (newId) {
          setIdeaId(newId)
          setMatchesTrigger(1) 
          loadIdeaMatches(text)
        } else {
          console.log(`did not receive request id for new idea`, response);
        }
      })
      .catch(console.log)
  }

  const getMatches = async () => {

    if (ideaId) {
      
      const res = await getIdeaMatches(ideaId, auth0);
      const matchesRes = res?.evidences || [];
      const computeStatus =  res?.computed
      
      if(computeStatus === 'done'){
        setComputed(true)
      }
      if(computeStatus === 'done' && res?.evidences.length === 0){
        setNoMatchFound(true);
      } else {
        setNoMatchFound(false);
      }
      
      if(weeks?.length === 0){
        setWeeks(res?.weeks)
      }
      if(quarters?.length === 0){
        setQuarters(res?.quarters)
      }
      
      setMatches(matchesRes);
      setDisplayedMatches(matchesRes);
      setMatchesTrend(matchesRes)

      if(res?.evidences?.length > 0){
        const strongMatchesItems = res?.evidences?.filter((matchItem: any)=> matchItem?.match?.level === 'Strong')
        setStrongMatches(strongMatchesItems)
        setDisplayedStrongMatches(strongMatchesItems)
        setMatchesTrend(strongMatchesItems);
        const matchesOrgs = strongMatchesItems?.map((a: any)=> a = a.company).filter((company: any)=> company?._id !== 'N/A')
        setMatchesCompanies(matchesOrgs)
      }

      if(matchesRes.length > 0){
        setLoadingEvidenceMatches(false)
      }
    }   
  };

  const chooseMatch = (id: string) => {

    setCardOpened(false);
  
    let found = null
    found = matches?.find((m: any) => m?._id === id) || null;

    if(!found){
      found = requestsMatches?.find((m: any) => m?._id === id) || {_id: ''};
    }

    setTimeout(() => {
      setChosenEvidence(found);
      setCardOpened(true);
    }, 68); 
  };


  const getRequestsMatches = async ()=>{
    ideaId && getRequestsMatchesForAnIdea(ideaId, auth0).then((res)=>{

      setRequestsMatches(res?.evidences)
      setDisplayedRequestsMatches(res?.evidences)
      
      if(res?.evidences?.length > 0){
        const strongRequestsMatchesItems = res?.evidences?.filter((matchItem: any)=> matchItem?.match?.level === 'Strong')
        setStrongRequestsMatches(strongRequestsMatchesItems)
        setDisplayedStrongRequestsMatches(strongRequestsMatchesItems)
        setRequestsMatchesTrend(strongRequestsMatchesItems)

        const matchesOrgs = strongRequestsMatchesItems?.map((a: any)=> a = a.company).filter((company: any)=> company?._id !== 'N/A')
        setRequestsMatchesCompanies(matchesOrgs)

      }
      if(res?.evidences?.length > 0){
        setLoadingEvidenceMatches(false)
      }
    }).catch(console.log)
  }
  
  async function fetchData() {
    try {
      await getMatches();
      await getRequestsMatches();
      matchesTimer()
    } catch (e) {
      console.log(e);
    }}
  
  async function fetchDiscoveryIdea(id: string) {
    try {
      const idea = await getDiscoveryIdea(id, auth0);
      console.log("fetchDiscoveryIdea", idea)
      if(idea?._id){
        setIdea(idea)
        setIdeaId(idea?._id)
        setDescription(idea?.description)
        loadIdeaMatches(idea?.description)
      }
    } catch (e) {
      console.log(e);
    }}

  async function fetchRecentQueries() {
    try {
      const queries = await getRecentQueries(auth0);
      if(queries.data){
        setRecentQueries(queries.data.recentQueries)
      }
    } catch (e) {
      console.log(e);
    }}
  
  useEffect(() => {

    if(ideaId){
      fetchData()
    }  
  }
  , [matchesTrigger, ideaId]);

  /* const filterRequests = (requests: any[], filters: any[]) => {
    
    if (
      !filters.length ||
      filters.every(
        (filter) => !filter.selected || filter.selected.length === 0
      )
    ) {
      return requests; 
    }

    return requests.filter((request) => {
      return filters.every((filter) => {
        const { parent, selected, name } = filter;
        if (!selected || selected.length === 0) return true; 

        const CurrentFilterConfig = findFilterByName(name, 'evidence', ideasFiltersConfig)

       
        const filterPath = CurrentFilterConfig?.dbFieldPath 
     

        if (!filterPath) return true; 

        const requestValue = getNestedProperty(request, filterPath);

        
        if (Array.isArray(requestValue)) {
          return requestValue
            .map((rV) => rV.toLowerCase())
            .some((r) => selected.includes(r.toLowerCase()));
        } else {
          return selected.includes(requestValue?.toLowerCase());
        }
      });
    });
  }; */


  useEffect(() => {

    const filteredMatches = filterRequests(matches, activeFilters, ideasFiltersConfig);
    const filteredRequestsMatches = filterRequests(requestsMatches, activeFilters, ideasFiltersConfig);

    const filteredStrongMatches = filterRequests(strongMatches, activeFilters, ideasFiltersConfig);
    const filteredStrongRequestsMatches = filterRequests(requestsMatches, activeFilters, ideasFiltersConfig);

    setDisplayedMatches(filteredMatches);
    setDisplayedRequestsMatches(filteredRequestsMatches)

    setDisplayedStrongMatches(filteredStrongMatches)
    setDisplayedStrongRequestsMatches(filteredStrongRequestsMatches)

    const noTrendFilters = activeFilters.filter(
      (filter) => filter.name !== "quarter" && filter.name !== "week"
    );

  
   
    const filteredMatchesTrend = filterRequests(strongMatches, noTrendFilters, ideasFiltersConfig);
    const filteredRequestsMatchesTrend = filterRequests(strongRequestsMatches, noTrendFilters, ideasFiltersConfig);
    
   
    setMatchesTrend(filteredMatchesTrend);
    setRequestsMatchesTrend(filteredRequestsMatchesTrend);
  }, [activeFilters]);


  useEffect(() => {
    if (activeSort) {
      setDisplayedMatches(prev => sortRequests(prev, activeSort));
    }
  }, [activeSort, ideaId]);


  useEffect(() => {

    /* const matchesMapped = matches.map(
      (m: any) => (m = { ...m, status: "match", source: "suggestion", isGapMatch : true })
    );

    const requestsMatchesMapped = requestsMatches.map(
      (m: any) => (m = { ...m, status: "match", source: "suggestion", isRequestMatch : true })
    ); */

    const allMatches = [...strongMatches, ...strongRequestsMatches]

    getCalculatedPerspectiveForRequestDiscoveryNew(allMatches, perspectiveConfigurations).then((data) => {
      setPerspectiveData((prev) => ({
        ...prev,
        ...data
      }));
    })
      .catch((error: any) => {
        console.error("Error recalculating company data:", error);
      });  
    
  }, [strongMatches, strongRequestsMatches]);


  return (
    <DiscoveryContext.Provider
      value={{
        ideaId,
        idea,
        setIdea,
        setIdeaId,
        revalidate,
        setRevalidate,
        matches,
        createIdeaDiscovery,
        chosenEvidence,
        chooseMatch,
        type,
        setType,
        perspectiveData,
        getMatches,
        matchesTimer,
        matchesTrigger,
        showValidated,
        showmatches,
        loadIdeaMatches,
        displayedMatches,
        setDisplayedMatches,
        setMatchesTrend,
        setRequestsMatchesTrend,
        setDisplayedRequestsMatches,
        activeSort,
        setActiveSort,
        cardOpened,
        setCardOpened,
        ideaMatches,
        setChosenEvidence,
        activeSearch,
        setActiveSearch,
        description, 
        setDescription, 
        convertFromDiscoveryToIdea, 
        loadingEvidenceMatches,
        loadingIdeasMatches,
        matchesCompanies,
        displayedRequestsMatches,
        requestsMatches,
        requestsMatchesCompanies,
        requestsMatchesTrend,
        matchesTrend,
        quarters,
        setQuarters,
        weeks,
        searchEvidence,
        query,
        searchedEvidence,
        loadingMatches,
        fetchDiscoveryIdea,
        fetchRecentQueries,
        recentQueries,
        setLoadingIdeasMatches,
        setLoadingEvidenceMatches,
        noMatchFound,
        setQueryLoader,
        queryLoader,
        setLoadingMatches,
        setComputed,
        setMatchesTrigger,
        strongRequestsMatches,
        displayedStrongMatches,
        displayedStrongRequestsMatches
      }}
    >
      {children}
    </DiscoveryContext.Provider>
  );
};

export { DiscoveryContext, DiscoveryContextProvider };
export default DiscoveryContext;



